import { InjectionToken } from '@angular/core';
import { AuthServiceInterface } from '@freelancer/auth';
import { LoginServiceInterface } from './login.interface';

export const LOGIN_REDIRECT_SERVICE = new InjectionToken<LoginServiceInterface>(
  'LoginServiceInterface',
);

export const LOGIN_AUTH_SERVICE = new InjectionToken<AuthServiceInterface>(
  'AuthServiceInterface',
);
